import socket from '../mixins/WebSocket.js';

export var ChatTimer = {
    mixins: [socket],
    data() {
        return {
            isTimerStarted: false,
            remainingTime: 0, // 15 minutes in seconds
            timer: null,
            currentTime: null
        }
    },

    mounted() {
        this.timer = setInterval(() => {
            this.currentTime = this.getCurrentTime();
          }, 1000);
    },

    methods: {
        getCurrentTime() {
            // Return formatted current time (you can adjust format as needed)
            return new Date();
        },

        startTimer() {
            var isFeedbackPopupVisibleCount = 0;
      
            if (Object.keys(this.getUserChatSession).length) {
              const sessionStartTime = new Date(this.getUserChatSession.session_started_at).getTime(); // Session start time
              const sessionTimeout = new Date(this.getUserChatSession.session_timeout).getTime(); // Session timeout
      
              const totalSessionDuration = Math.round((sessionTimeout - sessionStartTime) / 1000); // Total session duration in seconds
              const elapsedTime = Math.round((Date.now() - sessionStartTime) / 1000); // Time elapsed since session start
      
              // Calculate remaining time in seconds
              this.remainingTime = Math.max(0, totalSessionDuration - elapsedTime);
      
              if (this.remainingTime === 0) {
                console.log("Time's up!");
                this.isTimerStarted = false; // Toggle display
              } else {
                this.isTimerStarted = true; // Toggle display
      
                // Clear any existing timer to prevent overlapping intervals
                clearInterval(this.timerInterval);
      
                // Start the countdown
                this.timerInterval = setInterval(() => {
                  const now = Date.now();
                  const elapsedTime = Math.round((now - sessionStartTime) / 1000); // Update elapsed time
                  this.remainingTime = Math.max(0, totalSessionDuration - elapsedTime);
      
                  if (this.remainingTime === 0) {
                    console.log("Time's up!");
                    clearInterval(this.timerInterval); // Stop the timer
      
                    // Show feedback popup
                    if (this.userProfile.profession == 'Retail Investor' && !isFeedbackPopupVisibleCount) {
                      this.$emit('isFeedbackPopupVisible', true); // Emit feedback popup visibility
                      isFeedbackPopupVisibleCount++;
                    }
                  }
                }, 1000);
              }
            } else {
              this.remainingTime = 0;
              this.isTimerStarted = false; // Toggle display
            }
          },
    },

    computed: {
        userProfile() {
            return JSON.parse(localStorage.getItem('profile'));
        },

        getUserChatSession() {
            return this.$store.state.sessionDetails;
        },

        sessionTimerCount() {
          const minutes = Math.floor(this.remainingTime / 60);
          const seconds = this.remainingTime % 60;
          // console.log("minutes", minutes)
          return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
        },

        selectedUserForChat() {
            return this.$store.state.selectedUserForChat;
        },

        isSessionExpired() {
            let isExpired = false;
            if (Object.keys(this.getUserChatSession).length) {
              // const time = new Date(this.getUserChatSession.session_started_at);
      
              const endTime = new Date(this.getUserChatSession.session_timeout); // End time of the session
              // let time = new Date("Sun Jan 26 2025 23:49:36 GMT+0530 (India Standard Time)");
      
              // const endTime = new Date(time); // Example of a specific date and time
      
              // Get the current time in milliseconds
              const currentTime = this.currentTime;
      
              // // Calculate the difference in milliseconds
              // const timeDifference = currentTime - endTime;
      
              // Convert 15 minutes to milliseconds (15 * 60 * 1000)
              // const fifteenMinutesInMs = 15 * 60 * 1000;
      
              // // console.log("isSessionExpired", currentTime, givenTime, timeDifference, fifteenMinutesInMs);
              // // Check if the current time is greater than 15 minutes after the given time
              // if (timeDifference > fifteenMinutesInMs) { isExpired = true } else { isExpired = false };
      
              // Check if the current time is greater than the end time
              if (currentTime > endTime) {
                isExpired = true;
      
                // to inform backend that user session has over now
                // if(this.loggedInUserType != 'Active RA' || this.loggedInUserType != 'Non Active RA'){
      
                // let userSession = JSON.parse(localStorage.getItem("selectedUserForChat"));
      
                let user = JSON.parse(JSON.stringify(this.selectedUserForChat));
      
                if (user && user.status_str == 'Ongoing') {
                  console.log('marking session expired', user);
                  this.$set(user, "status_str", 'Completed');
      
                  this.$store.commit('commitSelectedUserForChatObj', user);
      
                  localStorage.removeItem('isSessionOngoing');
      
                  let room = user.title;
      
                  // this.$emit('sessionExpired', room);
      
                  if (this.loggedInUserType != 'Active RA' || this.loggedInUserType != 'Non Active RA') {
                    this.$socket.emit('mark_session_expired', { room, is_force_done: false });
                  }
                  localStorage.setItem("selectedUserForChat", {});
                  // Get plan details to update chat count
                  this.getPlanDetails();
                }
                // }
              } else {
                isExpired = false;
              }
            }
      
            return isExpired;
          },
    },

    beforeDestroy() {
        clearInterval(this.timer);
        // clearInterval(this.clearIsTypingEvent);
        // this.$socket.off();
      },
}